function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M69.4,47.8c-0.3,0-13.2,0-14.1,0c0.4-0.7,2.9-4.5,3-4.7h9.2l3.7-5.8l-21.1,0l-3.7,5.8h0.2c0.2,0,0.7,0,1.2,0 c1.2,0,2.9,0,3.4,0h0.1c-0.3,0.6-4.1,6.5-5.8,9.2c-0.3,0.6-0.6,1-0.7,1.2c-0.1,0.1-0.1,0.1-0.1,0.1l28.1,0 C73.3,52.8,82.6,38,83,37.3c0.4,0.6,2.9,4.5,3.3,5.2h-2.9l-3.7,5.8h0H90c0.1,0.2,3.2,5,3.3,5.2h7L83,26.4 C82.3,27.5,69.6,47.5,69.4,47.8 M79.1,26.8l-22.3,0l-3.6,5.8l22.3,0L79.1,26.8z"
});

var SvgLogoEa = function SvgLogoEa(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 80",
    style: {
      enableBackground: "new 0 0 145 80"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-ea.3fa45209.svg";
export { SvgLogoEa as ReactComponent };